import { api, wire } from "lwc";
import Card from "tds/card";
import { EffectAdapter } from "common/effectAdapter";
import { LabelsAdapter } from "common/labelsAdapter";

var data$9 = { viewMore: "Mehr anzeigen" };
data$9.viewMore;

var data$8 = { viewMore: "Show More" };
data$8.viewMore;

var data$7 = { viewMore: "Mostrar más" };
data$7.viewMore;

var data$6 = { viewMore: "Mostrar más" };
data$6.viewMore;

var data$5 = { viewMore: "Afficher plus" };
data$5.viewMore;

var data$4 = { viewMore: "Mostra altro" };
data$4.viewMore;

var data$3 = { viewMore: "さらに表示" };
data$3.viewMore;

var data$2 = { viewMore: "더 보기" };
data$2.viewMore;

var data$1 = { viewMore: "Mostrar mais" };
data$1.viewMore;

var data = { viewMore: "显示更多" };
data.viewMore;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class contentCollectionCard extends Card {
  @api layout = "stack";
  get ctaLabelViewMore() {
    return this.ctaLabel ?? (this.ctaHref ? this.labels.viewMore : null);
  }
  @wire(LabelsAdapter, {
    locales,
  })
  labels = {};
  handleCta(event) {
    this.dispatchEvent(
      new CustomEvent(event.type, {
        detail: event.detail,
      })
    );
  }
  @wire(EffectAdapter, {
    layout: "$layout",
  })
  onUpdateLayout() {
    this.template.host.setAttribute("data-layout", this.layout);
  }
}

export default contentCollectionCard;
